import * as React from 'react';

import { cn } from '#/lib/utils';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  theme?: 'light' | 'dark';
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, theme, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full',
          'form-input',
          {
            'form-input-dark': theme === 'dark',
          },
          className,
        )}
        rows={5}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
